/* Initialize all image slider sliders */
document.querySelectorAll('.image-slider').forEach((slider, index) => {
  const sliderDelay = parseInt(slider.dataset.delay) * 1000;

  const imageSlider = new Glide(slider, {
    type: 'carousel',
    startAt: 0,
    autoplay: sliderDelay
  });
  
  imageSlider.mount();
});